import { ButtonHTMLAttributes, forwardRef } from 'react'
import { cn } from '../utils/cn'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'download'
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'primary', children, ...props }, ref) => {
    const baseStyles = {
      primary: 'btn-primary',
      secondary: 'btn-secondary',
      download: 'btn-download',
    }

    return (
      <button
        ref={ref}
        className={cn(baseStyles[variant], className)}
        {...props}
      >
        {children}
      </button>
    )
  }
)

Button.displayName = 'Button'
